import { render, staticRenderFns } from "./DetailTee.vue?vue&type=template&id=30ab1579"
import script from "./DetailTee.js?vue&type=script&lang=js&external"
export * from "./DetailTee.js?vue&type=script&lang=js&external"
import style0 from "./DetailTee.vue?vue&type=style&index=0&id=30ab1579&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports